export default __webpack_public_path__ + "images/0xb8a32897016c1b2ee0797090162eafe58f032795.png";